/* eslint-disable @typescript-eslint/no-explicit-any */
import { isNumeric } from 'helpers';
import React, { FC } from 'react';
import styled from 'styled-components';
import { Space } from 'styles/constants';

interface Props {
	size?: Space | number;
	top?: Space | number;
	left?: Space | number;
	bottom?: Space | number;
	right?: Space | number;
	children?: React.ReactNode;
	style?: any;
}

const StyledPadding = styled.div<Props>`
	padding-left: ${({ size, left, theme }) => {
		if (!size && !left) return 0;
		if (left) {
			return !isNumeric(left) ? theme.space[left as Space] : `${left}px`;
		}
		if (size) {
			return !isNumeric(size) ? theme.space[size as Space] : `${size}px`;
		}
	}};
	padding-right: ${({ size, right, theme }) => {
		if (!size && !right) return 0;
		if (right) {
			return !isNumeric(right) ? theme.space[right as Space] : `${right}px`;
		}
		if (size) {
			return !isNumeric(size) ? theme.space[size as Space] : `${size}px`;
		}
	}};
	padding-top: ${({ size, top, theme }) => {
		if (!size && !top) return 0;
		if (top) {
			return !isNumeric(top) ? theme.space[top as Space] : `${top}px`;
		}
		if (size) {
			return !isNumeric(size) ? theme.space[size as Space] : `${size}px`;
		}
	}};
	padding-bottom: ${({ size, bottom, theme }) => {
		if (!size && !bottom) return 0;
		if (bottom) {
			return !isNumeric(bottom) ? theme.space[bottom as Space] : `${bottom}px`;
		}
		if (size) {
			return !isNumeric(size) ? theme.space[size as Space] : `${size}px`;
		}
	}};
`;

export const Padding: FC<Props> = props => {
	return (
		<StyledPadding style={props.style} {...props}>
			{props.children}
		</StyledPadding>
	);
};
